import { CalendarCheckIcon, CalendarXMarkIcon } from '@forwardflow/icons'
import { useDnDStageMappingContext } from '../../hooks/useDnDStageMappingContext'
import { DnDStageGroupDropZone } from '../DnDStageGroupDropZone'

interface AppointMentStagesTabProps {
   onRemoveStage?: (stageId: string) => void
   onRemoveTag?: (tagId: string) => void
}

export const AppointMentStagesTab = ({
   onRemoveStage,
   onRemoveTag,
}: AppointMentStagesTabProps) => {
   const { getStagesAndTagsByIdentifier } = useDnDStageMappingContext()
   const { stages: appointmentSetStages, tags: appointmentSetTags } =
      getStagesAndTagsByIdentifier('ff-appointment-set')

   const { stages: appointmentMissedStages, tags: appointmentMissedTags } =
      getStagesAndTagsByIdentifier('ff-appointment-missed')

   return (
      <div className="space-y-5">
         <DnDStageGroupDropZone
            isMandatory={true}
            stages={appointmentSetStages}
            tags={appointmentSetTags}
            title="Appointment Set"
            id="ff-appointment-set"
            key="ff-appointment-set"
            description="The lead has set an appointment"
            icon={<CalendarCheckIcon width={24} height={24} />}
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />

         <DnDStageGroupDropZone
            stages={appointmentMissedStages}
            tags={appointmentMissedTags}
            title="Appointment Missed"
            id="ff-appointment-missed"
            key="ff-appointment-missed"
            description="The lead has missed an appointment"
            icon={<CalendarXMarkIcon width={24} height={24} />}
            onClose={onRemoveStage}
            onCloseTag={onRemoveTag}
         />
      </div>
   )
}
